import { useParams } from "react-router-dom";
import { usePageTitle } from "@/hooks/use-page-title";
import { useCurrentOrg } from "@/hooks/use-current-org";
import { ProjectList } from "@/components/projects/ProjectList";
import { ProjectDetail } from "@/components/projects/ProjectDetail";
import { TaskDetail } from "@/components/projects/TaskDetail";

export function ProjectsPage() {
  usePageTitle("Projects");
  const { projectId, taskId } = useParams<{
    projectId: string;
    taskId: string;
  }>();
  const { isAdmin } = useCurrentOrg();

  if (projectId && taskId) {
    return (
      <TaskDetail projectId={projectId} taskId={taskId} isAdmin={isAdmin} />
    );
  }

  if (projectId) {
    return <ProjectDetail projectId={projectId} isAdmin={isAdmin} />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Projects</h1>
        <p className="text-muted-foreground">
          Manage projects and tasks for your organization
        </p>
      </div>
      <ProjectList isAdmin={isAdmin} />
    </div>
  );
}
